import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { REPORTS } from '../../constants';

import withModal from '../Modal/WithModal';
import { generateAreaReportLink } from '../../ajax/endpoints';
import './AreaReportsModal.css';
import { ViewerPrimaryColorUserStyle } from '../UserCustomization';
import svgInline from '../SvgInline/SvgInline';
import closeIcon from '../../shared/assets/icon-close.svg';

export class AreaReportsModalComponent extends Component {
  constructor(props) {
    super(props);
    const { area } = props;
    this.state = {
      title: `${area.name}`,
      report: { title: 'Community Profile', report: 'community_profile' },
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const report = REPORTS.US.find(rep => rep.report === event.target.value);
    this.setState({ [event.target.name]: report });
  }

  render() {
    const { onModalClick, area, type } = this.props;
    const { name, fipsCode: esriId, counties, state_cd, state } = area;
    const formattedTitle = type === 'counties' ? `${name} County, ${state_cd || state || ''}` : name;
    const id = type === 'regions' ? counties.map(c => c._id) : esriId;
    return (
      <div className="modal-wrapper area-modal">
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <div className="modal-header">
            <h2 className="modal-title">ESRI Reports</h2>
            <a tabIndex="0" onClick={onModalClick}>
              <div className="modal-close">
                {svgInline(closeIcon)}
              </div>
            </a>
          </div>
        </ViewerPrimaryColorUserStyle>
        <div className="modal-body demographic-modal-form">
          <h2>{name}</h2>

          <form >
            <div className="form-group">
              <label htmlFor="reportType">Report Type</label>
              <select
                className="form-control"
                name="report"
                id="report"
                value={this.state.report.report}
                onChange={this.handleChange}
              >
                {
                  REPORTS.US.map(report => (
                    <option key={report.report} value={report.report}>{report.title}</option>
                  ))
                }
              </select>
            </div>
          </form>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={generateAreaReportLink(type, {
              title: formattedTitle,
              id,
              report: this.state.report.report,
              reportTitle: this.state.report.title,
            })}
            onClick={onModalClick}
          >
            <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
              <button className="btn">Generate Report</button>
            </ViewerPrimaryColorUserStyle>
          </a>
        </div>
      </div>
    );
  }
}

AreaReportsModalComponent.propTypes = {
  onModalClick: PropTypes.func,
  area: PropTypes.object,
  type: PropTypes.string,
};

export default withModal(AreaReportsModalComponent, 'report');



// WEBPACK FOOTER //
// ./src/components/AreaReportsModal/AreaReportsModal.js